import React from 'react';
import { graphql } from 'gatsby';
import { Button } from '@agria/theme/src/components/button';
import {
  ArrowRight,
  Account,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  LinkedIn,
  Telephone,
  Plus,
  Download,
} from '@agria/theme/src/components/icon';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ThemeButtonKeys } from '@agria/theme/src/styles/tokens/buttons';

interface ButtonBarLinkProps {
  url: string;
  label: string;
}

interface ButtonBarLinkData {
  style: 'Primary' | 'Secondary' | 'Plain Text Link';
  icon: string;
  link: ButtonBarLinkProps;
}

interface ButtonBarLinkDataProps {
  data: ButtonBarLinkData;
  [key: string]: any;
}

const IconMap: { [key: string]: React.ComponentType } = {
  Arrow: ArrowRight,
  Account,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
  LinkedIn,
  Telephone,
  Plus,
  Download,
};

const StyledPlainTextLink = styled.a`
  ${({ theme: { space, media } }) => css`
    text-decoration: underline;
    text-align: left;
  `};
`;

export const ButtonBarLink: React.FC<ButtonBarLinkDataProps> = ({ data }) => {
  const Icon = IconMap[data.icon.charAt(0).toUpperCase() + data.icon.slice(1)];

  const isIconLeft = [
    'Account',
    'Facebook',
    'Instagram',
    'Twitter',
    'Youtube',
    'LinkedIn',
    'Telephone',
    'Plus',
    'Download',
  ].includes(data.icon);

  const isArrowRight = data.icon === 'Arrow';

  if (data.style === 'Plain Text Link') {
    return (
      <StyledPlainTextLink href={data.link?.url}>
        {data.link?.label}
      </StyledPlainTextLink>
    );
  }

  const toCamelCase = (input: string): ThemeButtonKeys => {
    const result = input
      .toLowerCase()
      .split(' ')
      .map((word, index) =>
        index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join('') as ThemeButtonKeys;

    return result;
  };

  return (
    <Button
      url={data.link?.url}
      label={data.link?.label}
      arrowRight={isArrowRight}
      iconLeft={isIconLeft ? <Icon /> : undefined}
      variant={toCamelCase(data.style)}
    />
  );
};

export const ButtonBarLinkQuery = graphql`
  fragment ButtonBarLink on UMBRACO_ButtonBarLinkComponentType {
    style
    icon
    link {
      ...Link
    }
  }
`;
